import environment from '../../../../environments/environment';
import { axiosInterceptor } from '../authInterceptor';


 
interface UsersSearchDetails {

  type?: string,
  userId?: number,
  clientId?: number,
  name?: string,
  firstName?: string,
  lastName?: string,
  page: number,
  size: number,
  isActive: string

}
export async function getUserInfoListDetails(userSearch: UsersSearchDetails) {
  try {
    const getAllUserResponse = await axiosInterceptor.post(`${environment.getUserDetails}`, userSearch);
    return getAllUserResponse;
  } catch (error: any) {
    return error;
  }
}

export async function getAllRolesInfo(clientId: number) {
  try {
    const getAllRoleResponse = await axiosInterceptor.get(`${environment.getAllRolesDetailsURL}?clientId=${clientId}`);
    return getAllRoleResponse;
  } catch (error: any) {
    return error;
  }
}

export async function getUserDetailsByMailId(emailId: string): Promise<any> {
  const url = `${environment.getUsersDeatailsByMail}${emailId}`;
  try {
    const response = await axiosInterceptor.get<any>(url, {
      headers: {
        // Add any required headers here
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user details', error);
    throw error; // Re-throw the error if you want the calling function to handle it
  }
}

export async function getAllRoleDetails(clientId: number) {
  try {
    const getAllRoles = await axiosInterceptor.get(`${environment.getAllRoles}?clientId=${clientId}`);
    return getAllRoles
  } catch (error: any) {
    return error;
  }
}
export async function deleteUserById(userId: number, clientId: number) {
  try {
    const deletedUserById = await axiosInterceptor.delete(`${environment.deleteUserURL}${userId}?clientId=${clientId}`);
    return { data: deletedUserById, error: undefined };
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    return { data: undefined, error: errorMessage };
  }

}

export async function userDetailsSave(usersInfo: any) {
  try {
    const response = await axiosInterceptor.post(`${environment.deleteUserURL}`, usersInfo);
    return response;
  } catch (error) {
    return error;
  }
}
export async function userDetailsUpdate(userId: any,userInfoUpdate: any) {
  try {
    const response = await axiosInterceptor.patch(`${environment.deleteUserURL}${userId}`,userInfoUpdate);
    return response;
  } catch (error) {
    return error;
  }
}


export async function getAzureUserInfo( name: string, userName: string,clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.azureNewUser}?name=${name}&mail=${userName}&clientId=${clientId}`, {
      headers: {
        'Content-Type': 'application/json',
        // Include any other headers you need here
      },
    });
    return response;
  } catch (error) {
    console.error('There was an error frf the user information!', error);
    throw error;
  }
}